import React from "react";
import { connect } from "react-redux";

import {
  vipTierIcon,
  orderOnline,
  percentageCoupon,
  freeShippingCoupon,
} from "../../../helpers/icons";
import { languages } from "../../../helpers/language";

const VipTierItem = ({ vipTeir, merchantData, customerData }) => {
  let { merchant } = merchantData;
  let { customer } = customerData;

  let details = {
    //new tags after update
    main_already_have_account:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.already_have_account"
      ],
    charity_title:
      languages[merchant?.customWidgetTheme?.language || "en"]["charity.title"],
    charity_donate:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "charity.donate"
      ],
    charity_title_ways:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "charity.title_ways"
      ],
    charity_donating:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "charity.donating"
      ],

    //vip
    vip_you_have_to:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.vip_you_have_to"
      ],
    vip_place_order:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.vip_place_order"
      ],
    vip_atleast:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.vip_atleast"
      ],
    vip_more_than:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.vip_more_than"
      ],
    vip_less_than:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.vip_less_than"
      ],
    vip_time:
      languages[merchant?.customWidgetTheme?.language || "en"]["main.vip_time"],
    vip_tier_title:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.vip_tier_title"
      ],
    become_vip_member:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.become_vip_member"
      ],
    become_vip_member_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.become_vip_member_desc"
      ],
    current_tier:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.current_tier"
      ],
    current_tier_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.current_tier_desc"
      ],
    current_tier_btn:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.current_tier_btn"
      ],
    on_your_store:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.on_your_store"
      ],
    vip_spent:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.vip_spent"
      ],
    order_title:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.order_title"
      ],
    order_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.order_desc"
      ],
    rules:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "vip_tier.rules"
      ],
    special_reward:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "vip_tier.special_reward"
      ],
    giftcard_order_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.giftcard_order_desc"
      ],
    current_tier:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.current_tier"
      ],
    points_title:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.points_title"
      ],
    percentage_discount_title:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "vip_tier.percentage_discount_title"
      ],
    percentage_discount_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "vip_tier.percentage_discount_desc"
      ],
    free_shipping_title:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "vip_tier.free_shipping_title"
      ],
    free_shipping_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "vip_tier.free_shipping_desc"
      ],
  };

  let order_desc = details.order_desc;

  order_desc = order_desc.replace(
    /{value}/g,
    `${merchant?.orderPoints} * ${vipTeir?.rewardTimes?.points ?? 1}`
  );
  order_desc = order_desc.replace(/{currency}/g, merchant?.currency?.symbol);
  order_desc = order_desc.replace(
    /{points_currency}/g,
    merchant?.pointsCurrency !== "Super-Points"
      ? merchant?.pointsCurrency
      : details.points_title
  );
  order_desc = order_desc.replace(
    /{amount_spent}/g,
    merchant?.waysToEarnSettings?.orderSpentForPoints || 1
  );

  let giftcard_order_desc = details.giftcard_order_desc;
  giftcard_order_desc = giftcard_order_desc.replace(
    /{value}/g,
    `${merchant?.currency?.symbol}${merchant?.orderGiftcard?.credit}`
  );
  giftcard_order_desc = giftcard_order_desc.replace(
    /{value2}/g,
    `${merchant?.currency?.symbol}${merchant?.orderGiftcard?.spent}`
  );

  let percentage_discount_desc = details.percentage_discount_desc;
  percentage_discount_desc = percentage_discount_desc.replace(
    /{value}/g,
    vipTeir?.percentageDiscount?.percentage
  );

  return (
    <div className="vipTiers-item-container">
      <div className="vipTiers-icon-title-container">
        <div className="vipTiers-icon-container">
          <img
            src={
              vipTeir?.icon ? vipTeir?.icon?.location : vipTierIcon("#262626")
            }
            alt="icon"
          />
        </div>
        <div className="vipTiers-title-container">
          <h3>{vipTeir.listName}</h3>
        </div>
      </div>
      <div className="vipTiers-rules-container">
        <h3 className="vipTiers-rules-text">
          {merchant?.currentPlan?.planName !== "free" &&
          merchant?.customWidgetTheme?.textCustomization
            ? merchant?.customWidgetTheme?.textCustomization?.rules
            : "Rules"}
        </h3>
        <div className="vipTiers-rules-items">
          {vipTeir.definition?.map((def, i) => (
            <li key={i} className="vipTiers-rules-item-text">{`${
              details.vip_you_have_to
            } ${
              def.metricsProperty === "placedOrders"
                ? details.vip_place_order
                : ""
            } 
          ${def.metricsProperty === "amountSpent" ? details.vip_spent : ""} 
                    ${
                      def.operation === "isAtLeast"
                        ? ` ${details.vip_atleast}`
                        : ""
                    }
                     ${
                       def.operation === "isGreaterThan"
                         ? ` ${details.vip_more_than}`
                         : ""
                     } 
                    ${
                      def.operation === "isLessThan"
                        ? ` ${details.vip_less_than}`
                        : ""
                    }
                    ${
                      def.operation === "isAtLeastOne"
                        ? ` ${details.vip_atleast} 1`
                        : ""
                    }
                    ${
                      def.operationValue
                        ? def.metricsProperty === "placedOrders"
                          ? def.operationValue
                          : def.metricsProperty === "amountSpent"
                          ? `${merchant?.currency?.symbol}${def.operationValue}`
                          : ""
                        : ""
                    }
                    ${
                      def.metricsProperty === "placedOrders"
                        ? details.vip_time
                        : ""
                    }
                    ${
                      def.metricsProperty === "amountSpent"
                        ? details.on_your_store
                        : ""
                    } 
                    `}</li>
          ))}
        </div>
      </div>
      {vipTeir?.automatedRewardStatus && (
        <div className="vipTiers-rewards-container">
          <h3 className="vipTiers-rewards-text">
            {merchant?.currentPlan?.planName !== "free" &&
            merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.specialRewards
              : details.special_reward}{" "}
            (
            {merchant.isGiftcardsActive
              ? vipTeir?.rewardTimes?.giftcard
              : vipTeir?.rewardTimes?.points}
            X)
          </h3>

          {((merchant?.isPointsActive && merchant?.waysToEarn?.order) ||
            (merchant.isGiftcardsActive &&
              merchant?.waysToEarnGiftcards?.order)) && (
            <div className="vipTiers-rewards-item-container">
              <div className="vipTiers-rewards-item-icon-container">
                <img
                  src={
                    merchant?.theme?.icons?.order?.type === "custom"
                      ? merchant?.theme?.icons?.order?.location
                      : orderOnline(merchant?.customWidgetTheme?.iconcolor)
                  }
                  alt="icon"
                  className="vipTiers-rewards-item-icon"
                />
              </div>
              <div className="vipTiers-rewards-item-details-container">
                <h3 className="vipTiers-rewards-item-text">
                  {merchant?.currentPlan?.planName !== "free" &&
                  merchant?.theme?.textCustomization?.earnType
                    ? merchant?.theme?.textCustomization?.earnType?.order ??
                      details.order_title
                    : details.order_title}
                </h3>
                <p className="vipTiers-rewards-item-subtext">
                  {merchant?.isPointsActive ? order_desc : giftcard_order_desc}
                </p>
              </div>
            </div>
          )}

          {vipTeir?.percentageDiscount?.automaticDiscountId && (
            <div className="vipTiers-rewards-item-container">
              <div className="vipTiers-rewards-item-icon-container">
                <img
                  src={percentageCoupon(merchant?.customWidgetTheme?.iconcolor)}
                  alt="icon"
                  className="vipTiers-rewards-item-icon"
                />
              </div>
              <div className="vipTiers-rewards-item-details-container">
                <h3 className="vipTiers-rewards-item-text">
                  {details.percentage_discount_title}
                </h3>
                <p className="vipTiers-rewards-item-subtext">
                  {percentage_discount_desc}
                </p>
              </div>
            </div>
          )}

          {vipTeir?.freeShipping?.automaticDiscountId && (
            <div className="vipTiers-rewards-item-container">
              <div className="vipTiers-rewards-item-icon-container">
                <img
                  src={freeShippingCoupon(
                    merchant?.customWidgetTheme?.iconcolor
                  )}
                  alt="icon"
                  className="vipTiers-rewards-item-icon"
                />
              </div>
              <div className="vipTiers-rewards-item-details-container">
                <h3 className="vipTiers-rewards-item-text">
                  {details.free_shipping_title}
                </h3>
                <p className="vipTiers-rewards-item-subtext">
                  {details.free_shipping_desc}
                </p>
              </div>
            </div>
          )}
        </div>
      )}
      {customer?.tierName === vipTeir?.listName && (
        <div className="vipTiers-current-tier-text-container">
          <span className="vipTiers-current-tier-text">
            {merchant?.currentPlan?.planName !== "free" &&
            merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.currentTier
              : details.current_tier}
          </span>
        </div>
      )}
      {vipTeir?.benefits?.length > 0 && (
        <div className="vipTiers-benefits-container">
          <h3 className="vipTiers-benefits-text">
            {merchant?.customWidgetTheme?.language === "gr"
              ? "Vorteile"
              : merchant?.currentPlan?.planName !== "free" &&
                merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.benefits
              : "Benefits"}
          </h3>
          {vipTeir?.benefits?.map((benefit, i) => (
            <p className="vipTiers-benefits-item">{benefit?.title}</p>
          ))}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  merchantData: state.MerchantReducer,
  customerData: state.CustomerReducer,
  appstateData: state.AppstateReducer,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(VipTierItem);
